module.exports = __webpack_public_path__ + "static/logo_tag-ca7ed663cd69b26094d349f00f347dcd.png";